import {
  grayColor,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  roseColor,
  teleColor,
  whiteColor,
  blackColor,
  hexToRgb
} from "assets/jss/material-dashboard-react.js";

const alertStyle = {
  alert: {
    borderRadius: "0",
    background: "#ffffff",
    border : "1px solid #dcdcdc"
  },
  info :{
    borderLeft: "8px solid #1e8ae7",
  },
  error :{
    borderLeft: "8px solid #f2171c"
  },
  success :{
    borderLeft: "8px solid #16a237"
  },
  warning :{
    borderLeft: "8px solid #f76c1f"
  },
};

export default alertStyle;
